(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-faq-page"] && !Shopify.designMode) return;
  try {
    
function initBsdFaq(root) {
  if (root.dataset.faqReady) return;
  root.dataset.faqReady = 'true';
  const search = root.querySelector('[data-faq-search]');
  const input = root.querySelector('[data-faq-input]');
  const clear = root.querySelector('[data-faq-clear]');
  const count = root.querySelector('[data-faq-count]');
  const empty = root.querySelector('[data-faq-empty]');
  const questions = Array.from(root.querySelectorAll('[data-faq-question]'));
  const groups = Array.from(root.querySelectorAll('[data-faq-group]'));
  const priorOpen = new Map();
  let searching = false;
  const update = () => {
    const query = input.value.trim().toLocaleLowerCase();
    if (query && !searching) questions.forEach(item => priorOpen.set(item, item.open));
    let matches = 0;
    questions.forEach(item => {
      const match = !query || item.textContent.toLocaleLowerCase().includes(query);
      item.hidden = !match;
      if (match) matches += 1;
      if (query) item.open = match;
      else if (searching) item.open = priorOpen.get(item) || false;
    });
    groups.forEach(group => { group.hidden = !Array.from(group.querySelectorAll('[data-faq-question]')).some(item => !item.hidden); });
    clear.hidden = !query;
    empty.hidden = matches > 0;
    count.textContent = query ? root.dataset.resultsTemplate.replace('__COUNT__', String(matches)) : '';
    searching = Boolean(query);
  };
  search.hidden = false;
  input.addEventListener('input', update);
  clear.addEventListener('click', () => { input.value = ''; update(); input.focus(); });
  root.querySelectorAll('[data-faq-topic]').forEach(link => link.addEventListener('click', () => { if (input.value) { input.value = ''; update(); } }));
}
document.querySelectorAll('[data-bsd-faq]').forEach(initBsdFaq);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bsd-faq]').forEach(initBsdFaq));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsd-article"]) return;
  try {
    
function bsdArticleContents(root) {
 root.querySelectorAll('[data-bsd-article]').forEach(article => {
  const contents = article.querySelector('[data-bsd-contents]');
  const list = contents.querySelector('ol');
  if (list.childElementCount) return;
  article.querySelectorAll('[data-bsd-prose] h2').forEach((heading, index) => {
   if (!heading.textContent.trim()) return;
   if (!heading.id) heading.id = 'guide-section-' + (index + 1);
   const link = document.createElement('a');
   link.href = '#' + heading.id;
   link.textContent = heading.textContent;
   const item = document.createElement('li');item.append(link);list.append(item);
  });
  if (list.childElementCount) contents.hidden = false;
  if (window.matchMedia('(min-width: 900px)').matches) contents.open = true;
 });
}
bsdArticleContents(document);
document.addEventListener('shopify:section:load', event => bsdArticleContents(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsd-category-filters"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var nav = document.querySelector('.bsd-cl-nav');
    if (!nav) return;

    /* Move nav bar after the hero heading but before the category cards */
    var hero = document.querySelector('.bsd-cl .bsd-cl-hero__title');
    if (hero) {
      var heroContainer = hero.closest('.container');
      heroContainer.parentNode.insertBefore(nav, heroContainer.nextSibling);
    } else {
      var landing = document.querySelector('.bsd-cl');
      if (landing) {
        landing.parentNode.insertBefore(nav, landing);
      }
    }

    /* Smooth scroll on click */
    nav.querySelectorAll('.bsd-cl-nav__item[data-scroll-to]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.getElementById(btn.getAttribute('data-scroll-to'));
        if (target) {
          var offset = window.innerHeight * 0.3;
          var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    /* Wrap both filter containers in a single shadow div */
    var topContainer = document.querySelector('.bsd-cl-filters-container--top');
    var bottomContainer = document.querySelector('.bsd-cl-filters-container--bottom');
    if (topContainer && bottomContainer) {
      var shadowWrap = document.createElement('div');
      shadowWrap.className = 'bsd-cl-shadow-wrap';
      topContainer.parentNode.insertBefore(shadowWrap, topContainer);
      shadowWrap.appendChild(topContainer);
      shadowWrap.appendChild(bottomContainer);

      /* Move the nav bar's pill directly above the shadow wrap, flush */
      var navBar = document.querySelector('.bsd-cl-nav__bar');
      var navWrap = document.querySelector('.bsd-cl-nav');
      if (navBar && navWrap) {
        /* Create a centering wrapper for the nav bar directly above shadow wrap */
        var navDock = document.createElement('div');
        navDock.className = 'bsd-cl-nav-dock';
        shadowWrap.parentNode.insertBefore(navDock, shadowWrap);
        navDock.appendChild(navBar);

        /* Add inverted corner connectors using SVG */
        var connSize = 16;
        var connSvg = '<svg width="'+connSize+'" height="'+connSize+'" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">';

        var connLeft = document.createElement('div');
        connLeft.className = 'bsd-cl-connector bsd-cl-connector--left';
        connLeft.innerHTML = connSvg + '<path d="M16,0 Q16,16 0,16 L16,16 Z" fill="#fff"/><path d="M16,0 Q16,16 0,16" fill="none" stroke="#e0e3e6" stroke-width="2"/></svg>';
        shadowWrap.appendChild(connLeft);

        var connRight = document.createElement('div');
        connRight.className = 'bsd-cl-connector bsd-cl-connector--right';
        connRight.innerHTML = connSvg + '<path d="M0,0 Q0,16 16,16 L0,16 Z" fill="#fff"/><path d="M0,0 Q0,16 16,16" fill="none" stroke="#e0e3e6" stroke-width="2"/></svg>';
        shadowWrap.appendChild(connRight);

        /* White cover bar to hide the card's top border under the nav bar */
        var coverBar = document.createElement('div');
        coverBar.className = 'bsd-cl-cover-bar';
        shadowWrap.appendChild(coverBar);

        function positionConnectors() {
          var navRect = navBar.getBoundingClientRect();
          var wrapRect = shadowWrap.getBoundingClientRect();
          connLeft.style.left = (navRect.left - wrapRect.left - connSize) + 'px';
          connRight.style.right = (wrapRect.right - navRect.right - connSize) + 'px';
          coverBar.style.left = (navRect.left - wrapRect.left) + 'px';
          coverBar.style.width = navRect.width + 'px';
        }
        /* Add subtle floating divider between nav and card */
        var divider = document.createElement('div');
        divider.className = 'bsd-cl-nav-divider';
        shadowWrap.appendChild(divider);

        function positionDivider() {
          var navRect = navBar.getBoundingClientRect();
          var wrapRect = shadowWrap.getBoundingClientRect();
          divider.style.left = (navRect.left - wrapRect.left + navRect.width * 0.15) + 'px';
          divider.style.width = (navRect.width * 0.7) + 'px';
        }

        positionConnectors();
        positionDivider();
        window.addEventListener('resize', function() {
          positionConnectors();
          positionDivider();
        });

        /* Hide the original nav container */
        navWrap.style.display = 'none';
      }
    }

    /* Move the Shop All CTA button below the shadow wrapper */
    var cta = document.querySelector('.bsd-cl-cta-wrap');
    var shadowEl = document.querySelector('.bsd-cl-shadow-wrap');
    if (cta && shadowEl) {
      shadowEl.parentNode.insertBefore(cta, shadowEl.nextSibling);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsd-signature-ranges"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bsd-signature-ranges')) {
    customElements.define('bsd-signature-ranges', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.cards = Array.from(this.querySelectorAll('[data-range-brand]'));
        this.buttons = Array.from(this.querySelectorAll('[data-range-filter]'));
        this.counter = this.querySelector('[data-range-count]');
        this.grid = this.querySelector('.bsd-ranges__grid');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.entering = [];
        this.querySelector('[data-range-toolbar]').hidden = false;
        this.buttons.forEach(button => {
          const brand = button.dataset.rangeFilter;
          button.addEventListener('click', () => this.filter(brand, true));
          // Start fetching a brand's lazy images on intent so they are ready by the time its cards fade in.
          ['pointerenter', 'touchstart', 'focus'].forEach(type => button.addEventListener(type, () => this.warm(brand), { passive: true, once: true }));
        });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-range-brand]');
          if (card) this.filter(card.dataset.rangeBrand);
        });
        this.filter('all');
      }
      matching(brand) {
        return this.cards.filter(card => brand === 'all'
          ? card.dataset.rangeFeatured === 'true'
          : card.dataset.rangeBrand === brand).slice(0, 8);
      }
      warm(brand) {
        this.matching(brand).forEach(card => card.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; }));
      }
      filter(brand, animate = false) {
        if (brand === this.current) return;
        this.current = brand;
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rangeFilter === brand)));
        this.counter.textContent = this.matching(brand).length;
        if (!animate || this.reducedMotion.matches || !Element.prototype.animate) {
          this.request = null;
          this.entering.forEach(animation => animation.cancel());
          this.entering = [];
          this.querySelectorAll('.bsd-ranges__grid--ghost').forEach(ghost => ghost.remove());
          this.show(brand);
          return;
        }
        // Only the latest click swaps once its photos are ready.
        const request = this.request = {};
        this.whenReady(brand).then(() => { if (this.request === request) this.swap(brand); });
      }
      // Wait briefly for the incoming photos so a card never fades in on an empty grey box.
      whenReady(brand) {
        this.warm(brand);
        const photos = this.matching(brand).map(card => card.querySelector('.bsd-ranges__photo')).filter(Boolean);
        const decoded = Promise.all(photos.map(photo => photo.decode().catch(() => {})));
        return Promise.race([decoded, new Promise(resolve => setTimeout(resolve, 200))]);
      }
      order(brand) {
        return this.buttons.findIndex(button => button.dataset.rangeFilter === brand);
      }
      show(brand) {
        const visible = this.matching(brand);
        this.cards.forEach(card => { card.hidden = !visible.includes(card); });
        this.displayed = brand;
      }
      parts(card) {
        return [card.querySelector('.bsd-ranges__image'), card.querySelector('.bsd-ranges__details'), card.querySelector('.bsd-ranges__photo, .bsd-ranges__placeholder')];
      }
      // A frozen copy of the outgoing cards sits on top of the new ones, so the grid is never empty.
      // Photo frames stay put: the photos crossfade while sliding a little inside their frame. Captions push
      // like a carousel inside their own card: the old one slides out as the new one slides in at the same
      // pace, clipped to the caption box, so the two never overlap. Direction follows the filter order.
      // Photos slide on `translate`, which leaves the zoom/focus `transform` set by the block untouched.
      swap(brand) {
        const direction = this.order(brand) > this.order(this.displayed) ? 1 : -1;
        const push = { duration: 380, easing: 'cubic-bezier(.4,0,.2,1)' };
        // Each clip edge tracks the slide, so the visible window stays put while the caption moves through it.
        const out = width => ({ opacity: 0, transform: `translateX(${direction * -width}px)`, clipPath: direction > 0 ? `inset(0 0 0 ${width}px)` : `inset(0 ${width}px 0 0)` });
        const into = width => ({ opacity: 0, transform: `translateX(${direction * width}px)`, clipPath: direction > 0 ? `inset(0 ${width}px 0 0)` : `inset(0 0 0 ${width}px)` });
        const current = element => {
          const style = getComputedStyle(element);
          return { opacity: style.opacity, transform: style.transform, clipPath: style.clipPath === 'none' ? 'inset(0px)' : style.clipPath };
        };
        const ghost = this.grid.cloneNode(false);
        ghost.removeAttribute('id');
        ghost.classList.add('bsd-ranges__grid--ghost');
        ghost.setAttribute('aria-hidden', 'true');
        ghost.inert = true;
        ghost.style.cssText = `left:${this.grid.offsetLeft}px;top:${this.grid.offsetTop}px;width:${this.grid.offsetWidth}px`;
        const exits = [];
        this.cards.filter(card => !card.hidden).forEach(card => {
          const clone = card.cloneNode(true);
          clone.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
          ghost.append(clone);
          const [image, details, photo] = this.parts(card);
          const [cloneImage, cloneDetails, clonePhoto] = this.parts(clone);
          exits.push(
            cloneImage.animate([{ opacity: getComputedStyle(image).opacity }, { opacity: 0 }], { duration: 240, easing: 'linear', fill: 'forwards' }),
            cloneDetails.animate([current(details), out(details.offsetWidth)], { ...push, fill: 'forwards' })
          );
          if (photo) exits.push(clonePhoto.animate(
            [{ translate: getComputedStyle(photo).translate }, { translate: `${direction * -15}%` }],
            { ...push, fill: 'forwards' }
          ));
        });
        this.grid.after(ghost);
        Promise.all(exits.map(animation => animation.finished)).then(() => ghost.remove(), () => ghost.remove());
        this.entering.forEach(animation => animation.cancel());
        this.show(brand);
        this.entering = [];
        this.cards.filter(card => !card.hidden).forEach(card => {
          const [image, details, photo] = this.parts(card);
          this.entering.push(
            image.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 320, delay: 20, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'backwards' }),
            details.animate([into(details.offsetWidth), { opacity: 1, transform: 'none', clipPath: 'inset(0px)' }], { ...push, fill: 'backwards' })
          );
          if (photo) this.entering.push(photo.animate([{ translate: `${direction * 15}%` }, { translate: '0px' }], { ...push, fill: 'backwards' }));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
